module.exports = __webpack_public_path__ + "images/stickers/huh@2x.4a513d5705f0f89b365f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/huh@2x.png
// module id = 1/Ri
// module chunks = 0